import * as yup from "yup"
import { ValidationErrorMessages } from "./interfaces"

export const sourceTextValidationSchema = yup
    .string()
    .required(ValidationErrorMessages.MISSING_SOURCE_TEXT)
    .max(3000, ValidationErrorMessages.OVERSIZED_SOURCE_TEXT)

export const targetTextValidationSchema = yup
    .string()
    .max(3500, ValidationErrorMessages.OVERSIZED_TARGET_TEXT)

export const fileNameExistsValidationSchema = yup
    .string()
    .required(ValidationErrorMessages.MISSING_FILE_NAME)
